import { useMemo } from 'react'
import { useRouter } from '@tanstack/react-router'

import { getEditorFromPathname } from '@common/editorFromPath'

import { MatchDetails } from '@common/types'

import { useCompetitionsListData } from '@queries/useCompetitionsListData'

import { useSearchState } from './useSearchState'

export function useSelectedMatchDetails(): MatchDetails {
    const router = useRouter()
    const [{ matchId: selectedMatchId }] = useSearchState()

    const editor = getEditorFromPathname(router.state.location.pathname)
    const { dataQualityMatches } = useCompetitionsListData(editor)

    const selectedMatchDetails = useMemo(() => {
        const selectedMatch = dataQualityMatches?.find(match => match.id.split(':').pop() === selectedMatchId)

        return {
            ...selectedMatch,
            id: selectedMatch?.id?.split(':').pop(),
        }
    }, [selectedMatchId, dataQualityMatches])

    return selectedMatchDetails
}
